import httpRequest from 'httpRequest'
import { IngredientContract, IngredientSlimModel, ItemContract } from 'models'

const INGREDIENT_PREFIX = '/company/ingredients'

const ingredientService = {
    getIngredients(includeProductAsIngredient: boolean = false) {
        return httpRequest.get<IngredientContract[]>(INGREDIENT_PREFIX, {
            params: { includeProductAsIngredient },
        })
    },
    getIngredientLookupList() {
        return httpRequest.get<IngredientSlimModel[]>(
            `${INGREDIENT_PREFIX}/lookup-list`,
        )
    },
    getIngredient(ingredientID: string) {
        return httpRequest.get<ItemContract>(
            `${INGREDIENT_PREFIX}/${ingredientID}`,
        )
    },
    createIngredient(data: ItemContract) {
        return httpRequest.post(`${INGREDIENT_PREFIX}`, data)
    },
    updateIngredient(ingredientID: string, data: ItemContract) {
        return httpRequest.put(`${INGREDIENT_PREFIX}/${ingredientID}`, data)
    },
    deleteIngredients(ingredientIDs: string[]) {
        return httpRequest.delete(`${INGREDIENT_PREFIX}`, {
            params: { ingredientIDs },
        })
    },
    activateIngredient(ingredientID: string) {
        return httpRequest.put(
            `${INGREDIENT_PREFIX}/${ingredientID}/update-active-flag`,
            {},
            {
                params: {
                    ingredientID,
                    isActive: true,
                },
            },
        )
    },
    deactivateIngredient(ingredientID: string) {
        return httpRequest.put(
            `${INGREDIENT_PREFIX}/${ingredientID}/update-active-flag`,
            {},
            {
                params: {
                    ingredientID,
                    isActive: false,
                },
            },
        )
    },
    importIngredient: (formData: FormData) =>
        httpRequest.post(`${INGREDIENT_PREFIX}/import`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        }),
    initLocationData: (ingredientID: string) =>
        httpRequest.post(
            `${INGREDIENT_PREFIX}/init-location-data/${ingredientID}`,
        ),
    availableIngredient(ingredientID: string) {
        return httpRequest.put(
            `${INGREDIENT_PREFIX}/${ingredientID}/update-available-flag`,
            {},
            {
                params: {
                    ingredientID,
                    isAvailable: true,
                },
            },
        )
    },
    unavailableIngredient(ingredientID: string) {
        return httpRequest.put(
            `${INGREDIENT_PREFIX}/${ingredientID}/update-available-flag`,
            {},
            {
                params: {
                    ingredientID,
                    isAvailable: false,
                },
            },
        )
    },
}

export default ingredientService
